import React, { PureComponent } from 'react';
import Ellipsis from '../common/Ellipsis';
import { generateDataAttr } from '../utils/generateDataAttr';

import { st, classes } from './TextButton.st.css';
import ButtonCore from '../Button/ButtonCore';
import { TextButtonProps } from './TextButton.types';

class TextButton extends PureComponent<TextButtonProps> {
  static displayName = 'TextButton';
  static defaultProps: TextButtonProps = {
    skin: 'standard',
    underline: 'none',
    size: 'medium',
    disabled: false,
    fluid: false,
    wrap: false,
    tooltipProps: {},
  };

  button = React.createRef<HTMLButtonElement>();

  /**
   * Sets focus on the element
   */
  focus = () => {
    this.button.current && this.button.current.focus();
  };

  render() {
    const {
      skin,
      underline,
      weight,
      size,
      children,
      className,
      dataHook,
      fluid,
      wrap,
      ellipsis,
      showTooltip,
      tooltipProps,
      ariaLabel,
      ariaLabelledBy,
      ariaHaspopup,
      ariaExpanded,
      ariaControls,
      ariaActiveDescendant,
      ...rest
    } = this.props;

    return (
      <Ellipsis
        ellipsis={ellipsis}
        showTooltip={showTooltip}
        {...tooltipProps}
        render={({ ref, ellipsisClasses }) => (
          <ButtonCore
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
            aria-haspopup={ariaHaspopup}
            aria-expanded={ariaExpanded}
            aria-controls={ariaControls}
            aria-activedescendant={ariaActiveDescendant}
            {...rest}
            {...generateDataAttr(this.props, [
              'skin',
              'size',
              'weight',
              'underline',
            ])}
            ref={this.button}
            className={st(
              classes.root,
              {
                skin,
                underline,
                weight,
                size,
                fluid,
                wrap,
                ellipsis,
              },
              className,
            )}
            data-hook={dataHook}
            contentClassName={ellipsisClasses()}
            contentRef={ref}
          >
            {children}
          </ButtonCore>
        )}
      />
    );
  }
}

export default TextButton;
